import React, { useState, useEffect } from 'react';
import './App.css';
import SeleccionModo from './components/SeleccionModo';
import SeleccionCategoria from './components/SeleccionCategoria';
import Pregunta from './components/Pregunta';
import ResultadoFinal from './components/ResultadoFinal';
import GeneradorPreguntas from './components/GeneradorPreguntas';
import MensajeCarga from './components/MensajeCarga';
import logo from './assets/nintendo_logo.webp';

function App() {
  const [modo, setModo] = useState('');
  const [categoria, setCategoria] = useState('');
  const [preguntas, setPreguntas] = useState([]);
  const [preguntaActual, setPreguntaActual] = useState(0);
  const [respuestas, setRespuestas] = useState([]);
  const [puntuacion, setPuntuacion] = useState(0);
  const [rango, setRango] = useState('');
  const [quizzesCompletados, setQuizzesCompletados] = useState({});
  const [modosDesbloqueadosPorCategoria, setModosDesbloqueadosPorCategoria] = useState({});
  const [mostrarMensajeDesbloqueo, setMostrarMensajeDesbloqueo] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [preguntasListas, setPreguntasListas] = useState(false);
  const [quizIniciado, setQuizIniciado] = useState(false);
  const [quizFinalizado, setQuizFinalizado] = useState(false);
  const [tiempoRestante, setTiempoRestante] = useState(30);
  const [timerActivo, setTimerActivo] = useState(false);
  const [errorGeneracion, setErrorGeneracion] = useState(false);
  const [mostrandoRespuestaCorrecta, setMostrandoRespuestaCorrecta] = useState(false);
  const [respuestaSeleccionada, setRespuestaSeleccionada] = useState(null);

  const explicacionesModo = {
    'Clásico': 'Responde correctamente la mayor cantidad de preguntas posibles.',
    'Sin fallos': 'El juego termina al primer error. ¿Cuántas preguntas puedes responder?',
    'Contrarreloj': 'Responde la mayor cantidad de preguntas en 30 segundos.'
  };

  useEffect(() => {
    let intervalo;
    if (timerActivo && tiempoRestante > 0) {
      intervalo = setInterval(() => {
        setTiempoRestante((tiempo) => tiempo - 1);
      }, 1000);
    } else if (tiempoRestante === 0 && modo === 'Contrarreloj') {
      finalizarQuiz(respuestas);
    }
    return () => clearInterval(intervalo);
  }, [timerActivo, tiempoRestante, modo]);

  useEffect(() => {
    document.body.className = '';

    if (categoria === 'Super Mario') {
      document.body.classList.add('super-mario');
    } else if (categoria === 'The Legend of Zelda') {
      document.body.classList.add('zelda');
    } else if (categoria === 'Pokémon') {
      document.body.classList.add('pokemon');
    } else if (categoria === 'Super Smash Bros.') {
      document.body.classList.add('super-smash-bros');
    }
  }, [categoria]);

  const responderPregunta = (respuestaSeleccionada) => {
    if (modo === 'Contrarreloj') {
      procesarRespuesta(respuestaSeleccionada);
    } else {
      setRespuestaSeleccionada(respuestaSeleccionada);
      setMostrandoRespuestaCorrecta(true);
      
      setTimeout(() => {
        procesarRespuesta(respuestaSeleccionada);
      }, 3000);
    }
  };

  const procesarRespuesta = (respuestaSeleccionada) => {
    const preguntaActualObj = preguntas[preguntaActual];
    const esCorrecta = respuestaSeleccionada === preguntaActualObj.respuestaCorrecta;
    
    const nuevasRespuestas = [...respuestas, respuestaSeleccionada];
    setRespuestas(nuevasRespuestas);

    if (esCorrecta) {
      setPuntuacion(puntuacionAnterior => puntuacionAnterior + 1);
    }

    if (modo === 'Sin fallos' && !esCorrecta) {
      finalizarQuiz(nuevasRespuestas);
    } else if (preguntaActual < preguntas.length - 1) {
      setPreguntaActual(preguntaActual + 1);
    } else {
      finalizarQuiz(nuevasRespuestas);
    }

    setMostrandoRespuestaCorrecta(false);
    setRespuestaSeleccionada(null);
  };

  const finalizarQuiz = (respuestasFinales) => {
    setTimerActivo(false);

    let nuevoRango;
    if (puntuacion <= 3) {
      nuevoRango = 'Novato';
    } else if (puntuacion <= 6) {
      nuevoRango = 'Intermedio';
    } else if (puntuacion <= 9) {
      nuevoRango = 'Experto';
    } else {
      nuevoRango = 'Maestro';
    }

    setRango(nuevoRango);

    const nuevosQuizzesCompletados = {
      ...quizzesCompletados,
      [categoria]: (quizzesCompletados[categoria] || 0) + 1
    };
    setQuizzesCompletados(nuevosQuizzesCompletados);

    if (nuevosQuizzesCompletados[categoria] === 3) {
      const nuevosModosDesbloqueados = {
        ...modosDesbloqueadosPorCategoria,
        [categoria]: ['Clásico', 'Sin fallos', 'Contrarreloj']
      };
      setModosDesbloqueadosPorCategoria(nuevosModosDesbloqueados);
      setMostrarMensajeDesbloqueo(true);
    } else {
      setMostrarMensajeDesbloqueo(false);
    }

    setQuizIniciado(false);
    setQuizFinalizado(true);
  };

  const reiniciarQuiz = () => {
    setPreguntas([]);
    setPreguntaActual(0);
    setRespuestas([]);
    setPuntuacion(0);
    setRango('');
    setPreguntasListas(false);
    setQuizIniciado(false);
    setQuizFinalizado(false);
  };

  const volverAlInicio = () => {
    setModo('');
    setCategoria('');
    reiniciarQuiz();
  };

  const volverACategoria = () => {
    setCategoria('');
    reiniciarQuiz();
  };

  const comenzarQuiz = () => {
    setQuizIniciado(true);
    if (modo === 'Contrarreloj') {
      setTiempoRestante(30);
      setTimerActivo(true);
    }
  };

  return (
    <div className="App">
      <div className="logo-container">
        <img src={logo} alt="Logo Nintendo Quiz" className="app-logo" />
      </div>
      <header className="App-header">
        {!categoria ? (
          <SeleccionCategoria setCategoria={setCategoria} />
        ) : !modo ? (
          <SeleccionModo 
            setModo={setModo} 
            modosDesbloqueados={modosDesbloqueadosPorCategoria[categoria]} 
            volverACategoria={volverACategoria}
            quizzesCompletados={quizzesCompletados[categoria] || 0}
          />
        ) : errorGeneracion ? (
          <div>
            <h2>{`Categoría: ${categoria}`}</h2>
            <h3>{`Modo: ${modo}`}</h3>
            <p>{explicacionesModo[modo]}</p>
            <p>Ocurrió un error al generar las preguntas</p>
            <div>
              <button onClick={() => {
                setModo('');
                setPreguntasListas(false);
                setErrorGeneracion(false);
              }} className="boton-volver">Volver</button>
            </div>
          </div>
        ) : !preguntasListas ? (
          <>
            <div>
              <h2>{`Categoría: ${categoria}`}</h2>
              <h3>{`Modo: ${modo}`}</h3>
              <p>{explicacionesModo[modo]}</p>
              {cargando && <MensajeCarga />}
            </div>
            <GeneradorPreguntas 
              categoria={categoria}
              modo={modo}
              setPreguntas={setPreguntas} 
              setCargando={setCargando}
              setPreguntasListas={setPreguntasListas}
              setErrorGeneracion={setErrorGeneracion}
            />
          </>
        ) : !quizIniciado && !quizFinalizado ? (
          <div>
            <h2>{`Categoría: ${categoria}`}</h2>
            <h3>{`Modo: ${modo}`}</h3>
            <p>{explicacionesModo[modo]}</p>
            <div>
              <button onClick={comenzarQuiz}>Comenzar Quiz</button>
            </div>
            <div>
              <button onClick={() => {
                setModo('');
                setPreguntasListas(false);
              }} className="boton-volver">Volver</button>
            </div>
          </div>
        ) : quizIniciado && !quizFinalizado ? (
          <div>
            <Pregunta 
              pregunta={preguntas[preguntaActual]} 
              responder={responderPregunta} 
              mostrandoRespuestaCorrecta={mostrandoRespuestaCorrecta}
              respuestaSeleccionada={respuestaSeleccionada}
            />
            {modo === 'Contrarreloj' && (
              <div>Tiempo restante: {tiempoRestante} segundos</div>
            )}
          </div>
        ) : quizFinalizado ? (
          <div>
            <ResultadoFinal 
              puntuacion={puntuacion} 
              rango={rango} 
              modo={modo}
              tiempoRestante={tiempoRestante}
            />
            {mostrarMensajeDesbloqueo && (
              <p>¡Felicidades! Has desbloqueado nuevos modos de juego para la categoría {categoria}: "Sin fallos" y "Contrarreloj"</p>
            )}
            <div>
              <button onClick={reiniciarQuiz}>Repetir Quiz</button>
            </div>
            <div>
              <button onClick={volverAlInicio} className="boton-volver">Volver al Inicio</button>
            </div>
          </div>
        ) : null}
      </header>
    </div>
  );
}

export default App;
